import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../../components/Footer";
import { useArticlesContext } from "../../context/ArticlesContext";
import MobileMapOverlay from "../../components/MobileMapOverlay";
import SocialMedia from "../../components/SocialMedia";
import Marker from "../../components/Marker";
import Top from "../../components-top/Top";
import Left from "../../components-top/Left";
import Right from "../../components-top/Right";
import Bottom from "../../components-top/Bottom";

export default function WeekTripFromVancouver() {
  // 1) Provide a unique reference ID (the slug in your ArticlesContext)
  const ref_id = "week-trip-from-vancouver";

  // 2) Access articles from your context (optional usage)
  const { articles } = useArticlesContext();
  const ref_data = articles.find((art) => art.slug === ref_id);

  // =========================================================
  // ========== SECTION TITLES IDS (Labels Map) ==============
  // =========================================================
  const labelsMap = {
    intro: "Introduction",
    "section-1": "Day 1: Vancouver Highlights",
    "section-2": "Day 2: Sea-to-Sky Road Trip",
    "section-3": "Day 3: Whistler Adventures",
    "section-4": "Day 4: Ferry to Victoria",
    "section-5": "Day 5: Victoria & Butchart Gardens",
    "section-6": "Day 6: Harrison Hot Springs",
    "section-7": "Day 7: Return to Vancouver",
    faq: "FAQ",
    "local-regulations": "Local Regulations",
    conclusion: "Conclusion",
    references: "References",
  };

  // ===================================
  // 4) References Data
  // ===================================
  const referencesData = [
    {
      url: "https://www.hellobc.com",
      label: "Destination BC (Official Tourism)"
    },
    {
      url: "https://www.bcferries.com",
      label: "BC Ferries"
    },
    {
      url: "https://bcparks.ca",
      label: "BC Parks Official Site"
    }
  ];

  // ===================================
  // 5) Locations for the Leaflet map
  // ===================================
  // Each location: id matches the relevant section, lat/lng are precise coords.
  // We have provided some approximate coords based on the itinerary.
  const locations = [
    {
      id: "section-1-stanley-park",
      lat: 49.30000,
      lng: -123.14000,
      popupText: "Stanley Park - Day 1"
    },
    {
      id: "section-1-aquarium",
      lat: 49.30000,
      lng: -123.13100,
      popupText: "Vancouver Aquarium - Day 1"
    },
    {
      id: "section-1-gastown",
      lat: 49.28440,
      lng: -123.10900,
      popupText: "Gastown & Steam Clock - Day 1"
    },
    {
      id: "section-1-granville-island",
      lat: 49.27260,
      lng: -123.13530,
      popupText: "Granville Island - Day 1"
    },
    {
      id: "section-1-canada-place",
      lat: 49.28870,
      lng: -123.11140,
      popupText: "Canada Place - Day 1"
    },
    {
      id: "section-2-capilano",
      lat: 49.34280,
      lng: -123.11220,
      popupText: "Capilano Suspension Bridge - Day 2"
    },
    {
      id: "section-2-shannon-falls",
      lat: 49.66700,
      lng: -123.16400,
      popupText: "Shannon Falls - Day 2"
    },
    {
      id: "section-2-sea-to-sky-gondola",
      lat: 49.67570,
      lng: -123.15700,
      popupText: "Sea to Sky Gondola - Day 2"
    },
    {
      id: "section-2-britannia-mine",
      lat: 49.62260,
      lng: -123.20390,
      popupText: "Britannia Mine Museum - Day 2"
    },
    {
      id: "section-2-squamish",
      lat: 49.70160,
      lng: -123.15500,
      popupText: "Squamish - Day 2"
    },
    {
      id: "section-2-whistler-village",
      lat: 50.11630,
      lng: -122.95740,
      popupText: "Whistler Village - Day 2"
    },
    {
      id: "section-3-peak-2-peak",
      lat: 50.11330,
      lng: -122.95470,
      popupText: "Whistler Gondola Base - Day 3"
    },
    {
      id: "section-3-lost-lake",
      lat: 50.12850,
      lng: -122.93710,
      popupText: "Lost Lake - Day 3"
    },
    {
      id: "section-3-lilwat-centre",
      lat: 50.12700,
      lng: -122.95480,
      popupText: "Squamish Lil’wat Cultural Centre - Day 3"
    },
    {
      id: "section-3-scandinave-spa",
      lat: 50.13000,
      lng: -122.94500,
      popupText: "Scandinave Spa Whistler - Day 3"
    },
    {
      id: "section-4-horseshoe-bay",
      lat: 49.37500,
      lng: -123.27200,
      popupText: "Horseshoe Bay Ferry Terminal - Day 4"
    },
    {
      id: "section-4-nanaimo",
      lat: 49.16400,
      lng: -123.94000,
      popupText: "Nanaimo Waterfront - Day 4"
    },
    {
      id: "section-4-malahat-viewpoint",
      lat: 48.56000,
      lng: -123.55000,
      popupText: "Malahat Summit Viewpoint - Day 4"
    },
    {
      id: "section-4-victoria-inner-harbour",
      lat: 48.42000,
      lng: -123.36800,
      popupText: "Victoria Inner Harbour - Day 4"
    },
    {
      id: "section-5-whale-watching",
      lat: 48.42500,
      lng: -123.36700,
      popupText: "Whale Watching Departure (Inner Harbour) - Day 5"
    },
    {
      id: "section-5-butchart",
      lat: 48.56610,
      lng: -123.47000,
      popupText: "Butchart Gardens - Day 5"
    },
    {
      id: "section-6-swartz-bay",
      lat: 48.69300,
      lng: -123.41000,
      popupText: "Swartz Bay Ferry Terminal - Day 6"
    },
    {
      id: "section-6-harrison",
      lat: 49.30000,
      lng: -121.77580,
      popupText: "Harrison Hot Springs - Day 6"
    },
    {
      id: "section-7-bridal-veil-falls",
      lat: 49.16290,
      lng: -121.74190,
      popupText: "Bridal Veil Falls (Optional stop) - Day 7"
    }
  ];

  // Keep references to textual sections for scroll linking
  const spotRefs = useRef({});
  const setSpotRef = (id, el) => {
    spotRefs.current[id] = el;
  };

  // Desktop map reference
  const mapRef = useRef(null);

  // MOBILE MAP
  const mobileMapRef = useRef(null);

  return (
    <>
      {/* ============ SEO & METADATA ============ */}
      <Helmet>
        <title>Week-Long Trip from Vancouver: Scenic Cities & Nature</title>
        <meta
          name="description"
          content="A comprehensive 7-day guide for an action-packed trip starting in Vancouver, including Whistler, Victoria, and Harrison Hot Springs."
        />
        <meta
          name="keywords"
          content="vancouver travel, whistler, victoria, sea to sky, bc ferries, harrison hot springs"
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.bcouver.com/articles/week-trip-from-vancouver.html"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Week-Long Trip from Vancouver: Scenic Cities & Nature"
        />
        <meta
          property="og:description"
          content="Explore Vancouver, Whistler, Victoria, and Harrison Hot Springs in one unforgettable week-long itinerary."
        />
        <meta
          property="og:image"
          content="https://bcouver.com/assets/images/week-trip-from-vancouver.jpg"
        />
        <meta
          property="og:url"
          content="https://www.bcouver.com/articles/week-trip-from-vancouver.html"
        />
        <meta property="og:type" content="article" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Week-Long Trip from Vancouver: Scenic Cities & Nature"
        />
        <meta
          name="twitter:description"
          content="Discover the best of British Columbia in 7 days, starting from Vancouver."
        />
        <meta
          name="twitter:image"
          content="https://bcouver.com/assets/images/week-trip-from-vancouver.jpg"
        />
      </Helmet>

      {/* ============ TOP NAVBAR + HERO ============ */}
      <Top ref_id={ref_id} />

      <main>
        <div className="container article-main">
          {/* LEFT COLUMN (TableOfContents + Map) */}
          <Left
            labelsMap={labelsMap}
            locations={locations}
            mapRef={mapRef}
            spotRefs={spotRefs}
          />

          {/* ============ ARTICLE CONTENT ============ */}
          <article className="article-content">
            {/* Featured Image */}
            <img
              src={
                ref_data?.image ||
                "https://bcouver.com/assets/images/article-fallback.jpg"
              }
              alt="Explore Vancouver and beyond in one exciting week"
              className="featured-image"
            />

            {/* Social Share */}
            <SocialMedia/>

            {/* SECTION: Introduction */}
            <h2 id="intro">Introduction</h2>
            <p>
              Vancouver, British Columbia, is a thriving urban center surrounded
              by towering mountains and the Pacific Ocean. It serves as the
              perfect launch point for a week-long adventure blending city
              sightseeing, road trips along scenic highways, ferry rides to
              picturesque islands, and rejuvenating visits to hot springs.
              Whether you want to explore vibrant city streets, hike through
              lush forests, spot wildlife, or simply relax by the water, this
              itinerary covers it all.
            </p>

            {/* SECTION: Day 1 */}
            <h2 id="section-1">Day 1: Vancouver Highlights</h2>
            <p>
              Begin your journey with an immersive exploration of Vancouver’s
              downtown and iconic attractions.
            </p>
            <p
              ref={(el) => setSpotRef("section-1-stanley-park", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Stanley Park</strong>{" "}
              <Marker
                coordY={49.30000}
                coordX={-123.14000}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – This expansive urban park features seawall trails, ancient cedar
              forests, and gorgeous waterfront views.
            </p>
            <p
              ref={(el) => setSpotRef("section-1-aquarium", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Vancouver Aquarium</strong>{" "}
              <Marker
                coordY={49.30000}
                coordX={-123.13100}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Located within Stanley Park, it’s home to over 65,000 animals,
              including sea otters, penguins, and tropical fish.
            </p>
            <p
              ref={(el) => setSpotRef("section-1-gastown", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Gastown & Steam Clock</strong>{" "}
              <Marker
                coordY={49.28440}
                coordX={-123.10900}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Stroll the cobblestone streets of Vancouver’s historic district,
              known for its Victorian architecture and the famous Steam Clock.
            </p>
            <p
              ref={(el) => setSpotRef("section-1-granville-island", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Granville Island</strong>{" "}
              <Marker
                coordY={49.27260}
                coordX={-123.13530}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Browse local produce and crafts at the Public Market, sample
              fresh seafood, and enjoy waterfront dining.
            </p>
            <p
              ref={(el) => setSpotRef("section-1-canada-place", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Canada Place</strong>{" "}
              <Marker
                coordY={49.28870}
                coordX={-123.11140}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Walk along the waterfront promenade for panoramic views of the
              North Shore mountains and Burrard Inlet.
            </p>

            {/* SECTION: Day 2 */}
            <h2 id="section-2">Day 2: Sea-to-Sky Road Trip to Whistler</h2>
            <p>
              Pick up your rental car and head north on Highway 99. This drive
              showcases coastal fjords, waterfalls, and epic mountain scenery.
            </p>
            <p
              ref={(el) => setSpotRef("section-2-capilano", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Capilano Suspension Bridge Park</strong>{" "}
              <Marker
                coordY={49.34280}
                coordX={-123.11220}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – A thrilling treetop adventure crossing a swaying bridge high
              above the forested canyon.
            </p>
            <p
              ref={(el) => setSpotRef("section-2-shannon-falls", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Shannon Falls Provincial Park</strong>{" "}
              <Marker
                coordY={49.66700}
                coordX={-123.16400}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Marvel at BC’s third-highest waterfall and stretch your legs on
              a short, scenic trail.
            </p>
            <p
              ref={(el) => setSpotRef("section-2-sea-to-sky-gondola", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Sea to Sky Gondola</strong>{" "}
              <Marker
                coordY={49.67570}
                coordX={-123.15700}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Ride up for panoramic views of Howe Sound, alpine forests, and
              dramatic peaks.
            </p>
            <p
              ref={(el) => setSpotRef("section-2-britannia-mine", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Britannia Mine Museum</strong>{" "}
              <Marker
                coordY={49.62260}
                coordX={-123.20390}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Discover the history of what was once the largest copper mine in
              the British Empire.
            </p>
            <p
              ref={(el) => setSpotRef("section-2-squamish", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Squamish</strong>{" "}
              <Marker
                coordY={49.70160}
                coordX={-123.15500}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Known as the “Outdoor Recreation Capital of Canada,” perfect for
              a lunch stop or short hike.
            </p>
            <p
              ref={(el) => setSpotRef("section-2-whistler-village", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Whistler Village</strong>{" "}
              <Marker
                coordY={50.11630}
                coordX={-122.95740}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Arrive by late afternoon to explore shops, restaurants, and the
              lively apres-ski (or apres-hike) scene.
            </p>

            {/* SECTION: Day 3 */}
            <h2 id="section-3">Day 3: Whistler Adventures & Relaxation</h2>
            <p>
              Immerse yourself in alpine landscapes with gondola rides, hiking,
              or mountain biking. Later, unwind at a forest spa.
            </p>
            <p
              ref={(el) => setSpotRef("section-3-peak-2-peak", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>PEAK 2 PEAK Gondola</strong>{" "}
              <Marker
                coordY={50.11330}
                coordX={-122.95470}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Soar between Whistler and Blackcomb mountains for breathtaking
              views of glaciers and valleys.
            </p>
            <p
              ref={(el) => setSpotRef("section-3-lost-lake", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Lost Lake</strong>{" "}
              <Marker
                coordY={50.12850}
                coordX={-122.93710}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Enjoy an easy forest walk or rent a bike to reach this tranquil
              swimming spot.
            </p>
            <p
              ref={(el) => setSpotRef("section-3-lilwat-centre", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Squamish Lil’wat Cultural Centre</strong>{" "}
              <Marker
                coordY={50.12700}
                coordX={-122.95480}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Learn about Indigenous art, history, and culture through
              immersive exhibits.
            </p>
            <p
              ref={(el) => setSpotRef("section-3-scandinave-spa", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Scandinave Spa Whistler</strong>{" "}
              <Marker
                coordY={50.13000}
                coordX={-122.94500}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – A soothing retreat featuring hot pools, cold plunges, saunas,
              and relaxation areas amidst the forest.
            </p>

            {/* SECTION: Day 4 */}
            <h2 id="section-4">Day 4: Ferry to Victoria, Vancouver Island</h2>
            <p>
              Depart Whistler, drive back down the Sea-to-Sky Highway, and catch
              a ferry from Horseshoe Bay to Nanaimo, then continue to Victoria.
            </p>
            <p
              ref={(el) => setSpotRef("section-4-horseshoe-bay", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Horseshoe Bay Ferry Terminal</strong>{" "}
              <Marker
                coordY={49.37500}
                coordX={-123.27200}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Reserve your BC Ferries spot in advance to avoid long waits.
            </p>
            <p
              ref={(el) => setSpotRef("section-4-nanaimo", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Nanaimo Waterfront</strong>{" "}
              <Marker
                coordY={49.16400}
                coordX={-123.94000}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Stretch your legs after the ferry ride, grab a Nanaimo Bar, or
              explore the harborfront walkway.
            </p>
            <p
              ref={(el) => setSpotRef("section-4-malahat-viewpoint", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Malahat Summit Viewpoint</strong>{" "}
              <Marker
                coordY={48.56000}
                coordX={-123.55000}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Enjoy spectacular vistas en route to Victoria.
            </p>
            <p
              ref={(el) => setSpotRef("section-4-victoria-inner-harbour", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Victoria Inner Harbour</strong>{" "}
              <Marker
                coordY={48.42000}
                coordX={-123.36800}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Stroll the waterfront, see the Parliament Buildings, and
              discover the city’s charming downtown.
            </p>

            {/* SECTION: Day 5 */}
            <h2 id="section-5">Day 5: Victoria & Butchart Gardens</h2>
            <p>
              Embark on a whale-watching tour in the morning, then visit
              world-renowned gardens in the afternoon.
            </p>
            <p
              ref={(el) => setSpotRef("section-5-whale-watching", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Whale Watching Departure</strong>{" "}
              <Marker
                coordY={48.42500}
                coordX={-123.36700}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Hop on a guided tour to spot orcas, humpbacks, and sea lions.
            </p>
            <p
              ref={(el) => setSpotRef("section-5-butchart", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Butchart Gardens</strong>{" "}
              <Marker
                coordY={48.56610}
                coordX={-123.47000}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Admire stunning floral displays across multiple themed gardens,
              including the famous Sunken Garden.
            </p>

            {/* SECTION: Day 6 */}
            <h2 id="section-6">Day 6: Ferry Back & Harrison Hot Springs</h2>
            <p>
              Take the Swartz Bay ferry to Tsawwassen and head east through the
              Fraser Valley to the peaceful oasis of Harrison Hot Springs.
            </p>
            <p
              ref={(el) => setSpotRef("section-6-swartz-bay", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Swartz Bay Ferry Terminal</strong>{" "}
              <Marker
                coordY={48.69300}
                coordX={-123.41000}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Another scenic ferry crossing among the Gulf Islands.
            </p>
            <p
              ref={(el) => setSpotRef("section-6-harrison", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Harrison Hot Springs</strong>{" "}
              <Marker
                coordY={49.30000}
                coordX={-121.77580}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – Relax in mineral-rich pools, stroll the lakefront, and enjoy
              small-town charm.
            </p>

            {/* SECTION: Day 7 */}
            <h2 id="section-7">Day 7: Return to Vancouver</h2>
            <p>
              Wrap up your adventure by driving back to Vancouver. If time
              permits, make a quick nature stop en route.
            </p>
            <p
              ref={(el) => setSpotRef("section-7-bridal-veil-falls", el)}
              style={{ scrollMarginTop: "80px" }}
            >
              <strong>Bridal Veil Falls (Optional)</strong>{" "}
              <Marker
                coordY={49.16290}
                coordX={-121.74190}
                mobileMapRef={mobileMapRef}
                mapRef={mapRef}
              />{" "}
              – A short trail leads to a misty 60m waterfall near Chilliwack.
            </p>
            <p>
              Arrive in Vancouver by afternoon, return your rental car, and take
              time to reflect on the incredible range of BC landscapes you’ve
              experienced in just one week.
            </p>

            {/* SECTION: FAQ */}
            <h2 id="faq">FAQ</h2>
            <div className="faq-section">
              <h3>1. When is the best time to do this trip?</h3>
              <p>
                Late spring through early fall offers the most reliable weather
                and open attractions. Winter is possible if you focus on ski
                activities and are prepared for potential road conditions.
              </p>

              <h3>2. Do I need a car for this itinerary?</h3>
              <p>
                A rental car is recommended for maximum flexibility, especially
                for exploring stops along the Sea-to-Sky Highway and Harrison.
                However, partial bus/ferry routes are available if you plan a
                more limited itinerary.
              </p>

              <h3>3. Are there any permits or reservations needed?</h3>
              <p>
                BC Ferries reservations are highly recommended in peak season.
                Some popular provincial parks (like Garibaldi) may require
                free day-use passes in summer. Always check official sources
                for up-to-date details.
              </p>
            </div>

            {/* SECTION: Local Regulations */}
            <h2 id="local-regulations">Local Regulations</h2>
            <p>
              Road safety laws require seatbelts for all passengers and ban
              hand-held phone use while driving. Winter tire regulations apply
              on certain highways from October to March. Alcohol consumption is
              restricted to licensed venues or private properties. In BC Parks,
              adhere to “Leave No Trace” principles: pack out all waste, stay on
              marked trails, and never feed wildlife.
            </p>

            {/* SECTION: Conclusion */}
            <h2 id="conclusion">Conclusion</h2>
            <p>
              In just seven days, you can experience the best of British
              Columbia’s urban and natural wonders. From Vancouver’s sparkling
              skyline to Whistler’s alpine thrills, Victoria’s coastal charm,
              and Harrison’s relaxing hot springs, this itinerary blends
              adventure, culture, and relaxation. Pack your bags and set off on
              an unforgettable week trip from Vancouver!
            </p>

            {/* BOTTOM COMPONENT: references, author, related articles, etc. */}
            <Bottom referencesData={referencesData} ref_data={ref_data} />
          </article>

          {/* RIGHT SIDE COLUMN */}
          <Right currentArticle={ref_data} />
        </div>
      </main>

      {/* MOBILE MAP OVERLAY */}
      <MobileMapOverlay
        ref={mobileMapRef}
        markers={locations}
        spotRefs={spotRefs}
      />

      <Footer />
    </>
  );
}